import { PublicNote } from '../../generated/interfaces';
import { ResolveData, Resolve } from '@angular/router';

export interface PublicNoteResolveData {
    notes: PublicNote[]
    users: { [id: number]: string }
}

export function createPublicNoteResolve(noteResolver: new (...args: any[]) => Resolve<PublicNoteResolveData>): ResolveData {
    return {
        data: noteResolver,
    };
}
